import React, { useContext } from 'react';
import { View, Text, StyleSheet, FlatList, TouchableOpacity, Platform } from 'react-native';
import LoadingIndicator from '../../../../components/ActivityIndicator';
import { MainColors } from '../../../../constants/Colors';
import FontSizes from '../../../../constants/FontSizes';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { OrganizationContext } from '../../../../context/OrganizationProvider';
import TwoLineMessage from '../../../../components/TwoLineMessage';
import useInfiniteScroll from '../../../../utils/useInfiniteScroll'
import useFetch from '../../../../utils/useFetch';

const UsersList = (props) => {
    const { get, post } = useFetch();
    const { organizationId } = useContext(OrganizationContext);

    const pageSize = 50;

    const getUsers = async (pageNumber) => await get(`/api/users?organizationId=${organizationId}&page=${pageNumber}&count=${pageSize}`);

    const [usersList, onScrollPage, onRefresh, isRefreshing, isLoading, mutate] = useInfiniteScroll(getUsers);

    const resendConfirmEmail = async (user) => {
        await post(`/api/users/resendConfirmEmail?organizationId=${organizationId}`, {
            userId: user.userId
        })
        user.hasHadConfirmEmailSentRecently = true
        mutate()
    }

    return (
        <View style={styles.container}>
            <LoadingIndicator isLoading={isRefreshing}>
                {usersList && usersList.length > 0 ? (
                    <FlatList
                        contentContainerStyle={{ padding: 20 }} // fix for shadow getting clipped (android)
                        data={usersList}
                        keyExtractor={(item) => item.userId.toString()}
                        ListFooterComponent={props.ListFooterComponent}
                        ListFooterComponentStyle={{ marginVertical: 30 }}
                        onEndReached={onScrollPage}
                        onEndReachedThreshold={5}
                        onRefresh={onRefresh}
                        refreshing={isRefreshing}
                        renderItem={({ item }) => (
                            <View style={styles.listItemContainer}>
                                <View style={{ }}>
                                    <Text style={styles.email}>{item.firstLoginDateUtc ? "😘" : "😶"}{item.email.toLowerCase()}</Text>
                                </View>
                                <View style={{ justifyContent: 'flex-end', flexDirection: 'row' }}>
                                    {!item.firstLoginDateUtc 
                                        && <TouchableOpacity style={styles.editButton}
                                            onPress={() => resendConfirmEmail(item)}>
                                            <MaterialCommunityIcons name="email-check-outline" size={24}
                                                color={!item.hasHadConfirmEmailSentRecently ? MainColors.primary : MainColors.secondary} />
                                        </TouchableOpacity>
                                    }
                                    <TouchableOpacity style={styles.editButton}
                                        onPress={() => props.onEditButtonPress(item.userId)}>
                                        <MaterialCommunityIcons name="square-edit-outline" size={24}
                                            color={MainColors.primary} />
                                    </TouchableOpacity>
                                </View>
                            </View>
                        )}
                    />
                ) : (
                    <TwoLineMessage
                        firstLine='Wow, so lonely up in here. 😢'
                        secondLine={'Let\'s add some people!'}
                        createMode={true}
                        onButtonPress={props.onEmptyUserListCreateBtnPress}
                        buttonText='Create New User'
                        buttonAccessibilityLabel='Create new user'
                        accessibilityHint='Press this button to create a new user'
                    />
                )
                }
            </LoadingIndicator>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    textContainer: {
        alignItems: 'center'
    },
    emptyUsersTextOne: {
        fontSize: FontSizes.medium,
        fontWeight: '700',
        color: MainColors.darkGray,
        paddingBottom: 8
    },
    emptyUsersTextTwo: {
        fontSize: FontSizes.medium,
        color: MainColors.darkGray
    },
    listItemContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginVertical: 10,
        paddingBottom: 5,
        borderBottomWidth: Platform.OS === 'web' ? 1 : 0,
        borderBottomColor: Platform.OS === 'web' ? MainColors.faintGray : null
    },
    email: {
        flexWrap: 'wrap',
        color: MainColors.darkGray,
        fontSize: FontSizes.medium,
        fontWeight: '500',
        letterSpacing: 0.8
    },
    editButton: {
        alignSelf: 'flex-end',
        paddingLeft: 8,
    }
});

export default UsersList;